<template>
  <div>
    <saticiortakbilgi
      v-bind:aktifmi="saticiBilgi"
      @dialogIptal="dialogCancel($event)"
      v-bind:faturalimi="disabledValue"
      ref="saticiortakbilgi"
      v-bind:kayitTarihi="kayitTarihi"
      v-bind:value="item"
      v-model="item"
    ></saticiortakbilgi>
    <iptaldialog
      v-bind:aktifmi="iptalStatus"
      ref="iptaldialog"
      :iptalNo="Number(iptalNo)"
      :iptalTipi="iptalTipi"
    ></iptaldialog>

    <v-flex v-if="kalemDiger" xs12 sm12 md12>
      <v-card light>
        <v-card-text>
          <v-flex xs12 sm12 md12 mt-1>
            <v-card>
              <v-layout row wrap align-center pl-1>
                <v-flex xs12 sm1 md1>
                  <strong>{{ $t(kalemAdi) }}</strong>
                </v-flex>
                <v-flex xs6 sm5 md1>
                  <v-list>
                    <v-list-tile>
                      <v-text-field
                        :label="$t('PNR-No')"
                        v-model="item.PNR_No"
                        disabled
                      ></v-text-field>
                    </v-list-tile>
                  </v-list>
                </v-flex>

                <v-flex xs6 sm6 md2>
                  <v-layout row wrap>
                    <v-list>
                      <v-list-tile v-if="(kalemAdi == 'Konsolosluk')">
                        <genelarama
                            apiname="SaticiAra"
                            :aktifmi="true"
                            :tip="11"
                            :label="this.$t('Seller-Code')"
                            v-model="item.satici"
                            @input="saticiKdvAyarla()"
                          ></genelarama>
                      </v-list-tile>
                      <v-list-tile v-else-if="(kalemAdi == 'Sigorta')">
                        <genelarama
                            apiname="SaticiAra"
                            :aktifmi="true"
                            :tip="14"
                            :label="this.$t('Seller-Code')"
                            v-model="item.satici"
                            @input="saticiKdvAyarla()"
                          ></genelarama>
                       
                      </v-list-tile>
                      <v-list-tile v-else>
                        <genelarama
                            apiname="SaticiAra"
                            :aktifmi="disabledValue"
                            :tip="10"
                            :label="this.$t('Seller-Code')"
                            v-model="item.satici"
                            @input="saticiKdvAyarla()"
                          ></genelarama>
                        <!-- <genelarama
                          apiname="SaticiAra"
                          :aktifmi="disabledValue"
                          :tip="10"
                          label="Satıcı Kod :"
                          v-model="item.satici"
                          @input="saticiKdvAyarla()"
                        ></genelarama> -->
                      </v-list-tile>
                    </v-list>
                  </v-layout>
                </v-flex>

                <v-flex xs6 sm3 md2>
                  <v-layout row wrap>
                    <v-list>
                      <v-list-tile>
                        <span class="subheading red--text ">
                          {{$t('Sales')}}&nbsp;:</span
                        >
                        <span class="ml-3">
                          <v-text-field
                            :label="$t('Sales')"
                            :disabled="disabledSatis"
                            v-model="item.yet_Satis"
                            @input="changeSalesInputPrice()"
                          ></v-text-field>
                        </span>
                      </v-list-tile>
                      <v-list-tile>
                        <span class="subheading red--text ">
                          {{$t('Buying')}}&nbsp;:</span
                        >
                        <span class="ml-3">
                          <v-text-field
                            :label="$t('Buying')"
                            v-model="item.yet_Alis"
                            :disabled="disabledAlis"
                            @input="changeCostInputPrice()"
                          ></v-text-field>
                        </span>
                      </v-list-tile>
                    </v-list>
                  </v-layout>
                </v-flex>
                <v-flex xs6 sm3 md1 v-show="$vuetify.breakpoint.xs">
                  <v-layout row wrap>
                    <v-list>
                      <v-list-tile>
                        
                        <v-text-field
                          :label="$t('Exchange-Rate-v2')" 
                          :disabled="disabledSatis"
                          v-model="item.satisPara.kur" 
                          @input="changeSalesInputPrice()" 
                        ></v-text-field>
                      </v-list-tile>
                      <v-list-tile>
                        <v-text-field
                          :label="$t('Exchange-Rate-v2')"
                          v-model="item.alisPara.kur"
                          @input="changeCostInputPrice()"
                        ></v-text-field>
                      </v-list-tile>
                    </v-list>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs6
                  sm3
                  md2
                  v-show="
                    $vuetify.breakpoint.sm ||
                    $vuetify.breakpoint.md ||
                    $vuetify.breakpoint.lg ||
                    $vuetify.breakpoint.xl
                  "
                >
                  <v-layout row wrap>
                    <v-list>
                      <v-list-tile>
                        <v-select
                          dense
                          height="12px"
                          hide-details
                          :disabled="disabledSatis"
                          :items="doviztipi"
                          v-model="item.satisPara.paraBirimi"
                          @input="getKur('satis')"
                          item-text="Title"
                          item-value="DovizKod"
                          :label="$t('Currency-Unit')"
                        ></v-select>
                      </v-list-tile>
                      <v-list-tile>
                        <v-select
                          dense
                          height="12px"
                          hide-details
                          :items="doviztipi"
                          :disabled="disabledAlis"
                          v-model="item.alisPara.paraBirimi"
                          @input="getKur('alis')"
                          item-text="Title"
                          item-value="DovizKod"
                          :label="$t('Currency-Unit')"
                        ></v-select>
                      </v-list-tile>
                    </v-list>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs3
                  sm3
                  md1
                  v-show="
                    $vuetify.breakpoint.md ||
                    $vuetify.breakpoint.lg ||
                    $vuetify.breakpoint.xl
                  "
                >
                  <v-layout row wrap>
                    <v-list>
                      <v-list-tile>
                        <v-text-field
                          :label="$t('Exchange-Rate-v2')"
                          :disabled="disabledSatis"
                          v-model="item.satisPara.kur"
                          @input="changeSalesInputPrice()"
                        ></v-text-field>
                      </v-list-tile>
                      <v-list-tile>
                        <v-text-field
                          :label="$t('Exchange-Rate-v2')"
                          :disabled="disabledAlis"
                          v-model="item.alisPara.kur"
                          @input="changeCostInputPrice()" 
                        ></v-text-field>
                      </v-list-tile>
                    </v-list>
                  </v-layout>
                </v-flex>

                <v-flex xs5 sm3 md2>
                  <v-layout row wrap>
                    <v-list>
                      <v-list-tile>
                        <v-text-field
                          :label="$t('Invoice-Number')"
                          disabled
                          v-model="FaturaNo"
                        ></v-text-field>
                      </v-list-tile>
                      <v-list-tile>
                        <v-text-field
                          :label="$t('VAT')"
                          :disabled="disabledSatis"
                          v-model="item.satis.KDVOran"
                        ></v-text-field>
                      </v-list-tile>
                    </v-list>
                  </v-layout>
                </v-flex>

                <v-flex xs5 sm3 md2 v-show="$vuetify.breakpoint.xs">
                  <v-layout row wrap>
                    <v-list>
                      <v-list-tile>
                        <v-select
                          dense
                          height="12px"
                          hide-details
                          :disabled="disabledSatis"
                          :items="doviztipi"
                          v-model="item.satisPara.paraBirimi"
                          @input="getKur('satis')"
                          item-text="Title"
                          item-value="DovizKod"
                          :label="$t('Sales-Currency-Type')"
                        ></v-select>
                      </v-list-tile>
                      <v-list-tile>
                        <v-select
                          dense
                          height="12px"
                          hide-details
                          :items="doviztipi"
                          :disabled="disabledAlis"
                          v-model="item.alisPara.paraBirimi"
                          @input="getKur('alis')"
                          item-text="Title"
                          item-value="DovizKod"
                          :label="$t('Purchase-Currency-Type')"
                        ></v-select>
                      </v-list-tile>
                    </v-list>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-layout row wrap justify-end>
                    <v-list>
                      <v-list-tile>
                        <v-btn
                          outline
                          small
                          fab
                          @click="saticiDialogAc()"
                          color="indigo"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </v-list-tile>
                      <v-list-tile v-if="item.PNR_No != null">
                        <v-btn
                          :disabled="disabledValue"
                          outline
                          small
                          fab
                          color="warning"
                          @click="iptalDialogAc()"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-list-tile>
                    </v-list>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import vize from "@/components/app/coper/vize/vize";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import tool from "@/components/app/coper/tools";
import auth from "../../../../../api/auth";
import saticiortakbilgi from "@/components/app/coper/vize/comp/saticiortakbilgi";
import iptaldialog from "@/components/app/coper/vize/comp/iptaldialog";
import helpers from "@/components/app/customcomp/helpers.js";


export default {
  props: {
    value: {
      type: Object,
    },
    kalemAdi: {
      type: String,
    },
    dovizList: {
      type: Array,
    },
    kayitTarihi: {
      type: String,
    },
    takipNo: {
      type: Number,
      default: 0,
    },
  },
  item: vize.KalemBase(),
  data() {
    return {
      saticiKonsoloslukItems:[],
      saticiSigortaItems:[],
      saticiItems:[],
      loading: false,
      kalemDiger: false,
      kalemSigorta: false,
      kalemKonsolosluk: false,
      stateSatici: [],
      itemsSatici: [],
      doviztipi: [],
      kurList: [],
      currencySales: 0,
      currencyCost: 0,
      currencyCounter: 0,
      FaturaNo: 0,
      disabledValue: false,
      disabledSatis: false,
      disabledAlis: false,
      saticiBilgi: false,
      iptalStatus: false,
      iptalNo: 0,
      iptalTipi: 0,
      getControl:true,
    };
  },
  components: {
    vize,
    genelarama,
    saticiortakbilgi,
    iptaldialog,
  },
  beforeMount: beforeMount,
  methods: {
    getKonsoloslukSaticilar()
    {
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 11,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
          this.saticiKonsoloslukItems = [];
          for (var i = 0; i < response.body.length; i++) {
            this.saticiKonsoloslukItems.push({
              id: response.body[i].id,
              isim: response.body[i].isim,
              KDV:response.body[i].KDV,
              kod: response.body[i].kod,
              CariKod:response.body[i].CariKod,
              YurtIci_YurtDisi:response.body[i].YurtIci_YurtDisi,
             
            });
          }

          
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getSigortaSaticilar()
    {
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 14,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
          this.saticiSigortaItems = [];
          for (var i = 0; i < response.body.length; i++) {
            this.saticiSigortaItems.push({
              id: response.body[i].id,
              isim: response.body[i].isim,
              KDV:response.body[i].KDV,
              kod: response.body[i].kod,
              CariKod:response.body[i].CariKod,
              YurtIci_YurtDisi:response.body[i].YurtIci_YurtDisi,
             
            });
          }

          
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getDigerSaticilar()
    {
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 10,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
          this.saticiItems = [];
          for (var i = 0; i < response.body.length; i++) {
            this.saticiItems.push({
              id: response.body[i].id,
              isim: response.body[i].isim,
              KDV:response.body[i].KDV,
              kod: response.body[i].kod,
              CariKod:response.body[i].CariKod,
              YurtIci_YurtDisi:response.body[i].YurtIci_YurtDisi,
             
            });
          }

          
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getCoperParaDeger() {
      return helpers.getCoperParaDeger();
    },
    dialogCancel(val) {
      this.item = val;
      this.saticiBilgi = false;
    },
    saticiDialogAc() {
      this.saticiBilgi = true;
      this.$refs.saticiortakbilgi.open(this.item);
    },
    iptalDialogAc() {
      
      this.iptalStatus = true;
      this.$refs.iptaldialog.open(this.item);
    },
    changeSalesInputPrice() {
      var SalesInputPrice = this.calculateInputCurrency(
        this.item.yet_Satis,
        1,
        this.item.satisPara.kur
      );
      this.$emit("kurSatisHesapla", Number(SalesInputPrice).toFixed(2));
    },
    changeCostInputPrice() {
      var CostInputPrice = this.calculateInputCurrency(
        this.item.yet_Alis,
        1,
        this.item.alisPara.kur
      );
     
      this.$emit("kurAlisHesapla", Number(CostInputPrice).toFixed(2));
    },
    calculateInputCurrency(amount, toValue, fromValue) {
      var result = 0;
      if (amount != 0) {
        result = (amount * fromValue) / toValue;
      } else {
        result = 0;
      }
      return result;
    },
    calculateCurrency(amount, toValue, fromValue, controlValue) {
      var result = 0;
      if (toValue != 1) {
        //  TL ise hesaplama direk gönder
        if (amount != 0) {
          if (controlValue != 0) {
            result = (controlValue * toValue) / fromValue;
          } else {
            result = (amount * toValue) / fromValue;
          }
        } else {
          result = 0;
        }
      } else {
        result = amount;
      }
      return result;
    },
    calculateSalesCurrency(amount, toValue, fromValue) {
      var salesCurrency = 0;
      salesCurrency = this.calculateCurrency(
        amount,
        toValue,
        fromValue,
        this.currencySales
      );
      this.currencySales = salesCurrency;
      this.$emit("kurSatisHesapla", Number(salesCurrency).toFixed(2));
    },
    calculateCostCurrency(amount, toValue, fromValue) {
      var costCurrency = 0;
      costCurrency = this.calculateCurrency(
        amount,
        toValue,
        fromValue,
        this.currencyCost
      );
      this.currencyCost = costCurrency;
      this.$emit("kurAlisHesapla", Number(costCurrency).toFixed(2));
    },
    saticiKdvAyarla() {
      this.item.satis.KDVOran = this.item.satici.KDV;
    },
    getKur(val) {
      if (this.kurList.length == 0) {
        if (this.kayitTarihi == null) {
          this.kayitTarihi = tool.Now_yyyy_MM_dd();
        }

        tool
          .http_post(this, "KurAra", {
            tarih: this.kayitTarihi,
          })
          .then(
            (response) => {
              this.kurList = response.body;
              this.selectKur(val);
            },
            (response) => {
              this.item.satisPara.kur = 1;
            }
          );
      } else {
        this.selectKur(val);
      }
    },
    selectKur(tip) {
      if (tip == "satis") {

        var p = this.kurList.find(this.paraAraSatis);
        if (p == undefined) {
          this.calculateSalesCurrency(
            this.item.yet_Satis,
            1,
            this.item.satisPara.kur
          );
          this.item.satisPara.kur = 1;
        } else {
          this.calculateSalesCurrency(
            this.item.yet_Satis,
            p.kur,
            this.item.satisPara.kur
          );
          this.item.satisPara.kur = p.kur;
        }
      } else if (tip == "alis") {
        var p = this.kurList.find(this.paraAraAlis);
        if (p == undefined) {
          this.calculateCostCurrency(
            this.item.yet_Alis,
            1,
            this.item.alisPara.kur
          );
          this.item.alisPara.kur = 1;
        } else {
          this.calculateCostCurrency(
            this.item.yet_Alis,
            p.kur,
            this.item.alisPara.kur
          );
          this.item.alisPara.kur = p.kur;
        }
      }
    },
    paraAraSatis: paraAraSatis,
    paraAraAlis: paraAraAlis,
  },
};

function beforeMount() {
  if (this.value != "undefined" && this.value != null && this.value != "") {
    //Satici alanı dolduruluyor
    
    if (typeof this.value.satici.kod !== "undefined" && this.value.satici.kod) {
     // var saticiBilgileri = this.value.satici.kod.split("-");
      this.value.satici.kod = this.value.satici.kod;
    }
    this.item = this.value;
    this.kalemDiger = true;
    this.doviztipi = this.dovizList;

    
    this.getKonsoloslukSaticilar();
    this.getSigortaSaticilar();

    //İptal Dialog bilgileri dolduruluyor
  
    if (this.kalemAdi == "Konsolosluk") {
      this.iptalNo = this.takipNo;
      this.iptalTipi = 2;
    } else {
      this.iptalNo = this.item.PNR_No;
      this.iptalTipi = 1;
      
    }
    
    //Faturalı kontrolu yapılıp kapatılacak alanlar belirleniyor
    if (this.value.faturaBilgileri && this.value.faturaBilgileri.length) {
      if (this.value.faturaBilgileri[0].FatTip == 2) {
        // Satış Fatura
        this.disabledSatis = true;
        this.disabledValue = true;
      } else if (this.value.faturaBilgileri[0].FatTip == 1) {
        // Gelen(Alış) Fatura
        this.disabledAlis = true;
        this.disabledValue = true;
      } else if (this.value.faturaBilgileri[0].FatTip == 3) {
        // Komisyon Fatura
        this.disabledSatis = true;
        this.disabledValue = true;
        this.disabledAlis = true;
      } else if (this.value.faturaBilgileri[0].FatTip == 4) {
        //Iade Fatura
        this.disabledValue = true;
        this.disabledAlis = true;
      } else if (this.value.faturaBilgileri[0].FatTip == 5) {
        //SatisIade Fatura
        this.disabledSatis = true;
        this.disabledValue = true;
      }
      this.FaturaNo = this.value.faturaBilgileri[0].FatNo;
    }
  }
}

function paraAraSatis(paraBirimi) {
  return paraBirimi.paraBirimi == this.item.satisPara.paraBirimi;
}

function paraAraAlis(paraBirimi) {
  return paraBirimi.paraBirimi == this.item.alisPara.paraBirimi;
}
</script>

<style>
</style>
